import React from 'react';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner.jsx';
import config from './config/config.json';

var HostName = config.HostName;
class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            responseString: '',
            submitted: false,
            loading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    handleSubmit(e) {
        this.setState({ loading: true });
        e.preventDefault();
        var url = HostName + "/api/v1/login";
        axios.post(url, {
            "userName": this.state.username,
            "password": this.state.password
        }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },timeout: config.TimeOut
            }).then(resp => {
                this.setState({ loading: false });
                this.setState({ responseString: resp.data.message });
                localStorage.setItem("idToken", resp.data.data.idtoken);
                localStorage.setItem("accessToken", resp.data.data.accesstoken);
                console.log("User Authentication successful.");
                this.props.history.push('/Home');
            })
            .catch(error => {
                console.log("User Authentication failed.");
                this.setState({ responseString: error.response.data.message });
                this.setState({ loading: false });
            });
    }

    render() {
        const { username, password, submitted } = this.state;
        return (

            <div className="col-md-6 col-md-offset-3">
                <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />

                <h2>Login</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                        <label htmlFor="username">Username</label>
                        <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} />
                        {submitted && !username &&
                            <div className="help-block">{this.setState.responseString = "Username is required"}</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                        <label htmlFor="password">Password</label>
                        <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                        {submitted && !password &&
                            <div className="help-block">{this.setState.responseString = "Password is required"}</div>
                        }
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary">Login</button>
                    </div>
                    <div>
                        {
                            this.state.loading ? <LoadingSpinner /> : null
                        }
                    </div>
                    <div>
                        <p><font color="red">{this.state.responseString}</font></p>
                    </div>
                </form>
            </div>
        );
    }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/LoginPage.jsx